import type React from "react";

interface DashboardMetricCardProps {
  title: string;
  value: string | number;
  label: string;
  icon: React.ReactNode;
}

export const DashboardMetricCard: React.FC<DashboardMetricCardProps> = ({
  title,
  value,
  label,
  icon,
}) => {
  return (
    <div className="innovation-dashboard__metric-card">
      <div className="innovation-dashboard__metric-head">
        <span>{title}</span>
        <span className="innovation-dashboard__metric-icon">{icon}</span>
      </div>
      <div className="innovation-dashboard__metric-value">{value}</div>
      <div className="innovation-dashboard__metric-caption">{label}</div>
    </div>
  );
};
